var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_317_3228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.0074 21.2771C36.6256 20.8953 36.0074 20.8953 35.6256 21.2771C35.2448 21.658 35.2448 22.2761 35.6256 22.6579C36.0074 23.0398 36.6256 23.0398 37.0074 22.6579C37.3884 22.2761 37.3884 21.658 37.0074 21.2771Z",
    fill: "url(#paint0_linear_317_3228)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1366 6.38561L43.612 0.861128C42.4671 -0.283592 40.6143 -0.283983 39.4692 0.861128L37.6977 2.6326C36.9713 3.35896 36.6933 4.38171 36.9124 5.35358L28.9035 6.76676C27.1174 7.08287 25.4968 7.9271 24.2175 9.20756L22.5054 10.9187C21.3779 12.0462 20.9184 13.5926 21.1264 15.0616C19.6464 14.8526 18.1129 15.3121 16.9821 16.4429C15.8529 17.5714 15.3912 19.1036 15.6001 20.5867C14.1207 20.3786 12.5876 20.8375 11.4576 21.9675C10.3605 23.0645 9.86083 24.5835 10.0766 26.1128C8.60742 25.9046 7.06095 26.3641 5.93322 27.4917L1.99857 31.4254C-0.666158 34.0903 -0.666256 38.4274 1.99867 41.0936L8.9041 47.9989C11.5698 50.6634 15.9066 50.6641 18.5722 47.9987L22.5057 44.0642C23.6334 42.9365 24.0929 41.3897 23.8845 39.9204C25.407 40.1351 26.9287 39.6412 28.03 38.5399C29.1573 37.4126 29.6167 35.8662 29.4086 34.3969C30.923 34.6107 32.447 34.124 33.5544 33.0155C34.6819 31.8881 35.1412 30.3419 34.9332 28.873C36.462 29.0888 37.9815 28.5895 39.0791 27.4918L40.7896 25.7805C42.0706 24.5006 42.9147 22.8799 43.2309 21.0933L44.6439 13.0851C45.6139 13.3037 46.6371 13.0278 47.365 12.2998L49.1365 10.5284C50.2815 9.38344 50.2817 7.53062 49.1366 6.38561ZM21.1245 42.6832L17.1911 46.6176C15.2876 48.5212 12.1893 48.5211 10.285 46.6176L3.37991 39.7127C1.47631 37.8082 1.47631 34.7101 3.37972 32.8065L7.31436 28.8729C8.45664 27.7305 10.3153 27.7305 11.4577 28.8729L21.1246 38.5397C22.267 39.6821 22.267 41.5408 21.1245 42.6832ZM26.6488 37.1588C25.507 38.3006 23.6522 38.3053 22.5056 37.1588L12.8386 27.4918C11.694 26.3471 11.6937 24.4935 12.8387 23.3485C13.9826 22.2046 15.8349 22.2042 16.9812 23.3478C16.9815 23.3481 16.9817 23.3483 16.982 23.3486L26.6485 33.015L26.6486 33.0151V33.0152C27.7907 34.1581 27.7909 36.0168 26.6488 37.1588ZM32.173 31.6348C31.0294 32.7798 29.1743 32.78 28.0301 31.6344L18.3628 21.9673C17.2175 20.8227 17.2169 18.9694 18.3631 17.8241C19.5085 16.6787 21.3599 16.6785 22.5055 17.8241L32.1734 27.492C33.3156 28.634 33.3156 30.4923 32.173 31.6348ZM41.3075 20.7536C41.0616 22.1431 40.4052 23.4037 39.4085 24.3994L37.6978 26.111C36.5555 27.2534 34.6968 27.2534 33.5544 26.111L23.8865 16.4431C22.7443 15.3007 22.7443 13.4421 23.8863 12.2999L25.5987 10.5885C26.5938 9.59243 27.8545 8.93598 29.2434 8.69009L38.0572 7.13492L42.8626 11.9404L41.3075 20.7536ZM47.7554 9.14731L45.984 10.9188C45.6023 11.3003 44.985 11.3004 44.6033 10.9188L39.0789 5.3943C38.6974 5.01257 38.6973 4.39538 39.079 4.01365L40.8505 2.24217C41.2322 1.86054 41.8495 1.86063 42.2311 2.24217L47.7554 7.76665C48.1364 8.14771 48.1378 8.76479 47.7554 9.14731Z",
    fill: "url(#paint1_linear_317_3228)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3566 36.9902L45.0051 28.465C44.8382 28.1381 44.5023 27.9324 44.1353 27.9324C43.7683 27.9324 43.4323 28.1381 43.2655 28.465L38.9142 36.9898C36.9365 40.8591 39.7547 45.5104 44.1353 45.5104C48.515 45.5104 51.3343 40.8598 49.3566 36.9902ZM44.1353 43.5573C41.212 43.5573 39.3376 40.4528 40.6537 37.8782L44.1353 31.057L47.6172 37.8786C48.9315 40.4504 47.0613 43.5573 44.1353 43.5573Z",
    fill: "url(#paint2_linear_317_3228)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.245 18.5144L29.5302 13.7996C29.1487 13.4182 28.5306 13.4182 28.149 13.7996C27.7677 14.1809 27.7677 14.7993 28.149 15.1806L32.8639 19.8954C33.2453 20.2768 33.8635 20.2768 34.245 19.8954C34.6264 19.514 34.6264 18.8957 34.245 18.5144Z",
    fill: "url(#paint3_linear_317_3228)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_317_3228",
    x1: 36.3166,
    y1: 20.9907,
    x2: 36.3166,
    y2: 22.9443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBB011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#ED861D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_317_3228",
    x1: 24.9977,
    y1: 0.00244141,
    x2: 24.9977,
    y2: 49.9975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBB011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#ED861D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_317_3228",
    x1: 44.1353,
    y1: 27.9324,
    x2: 44.1353,
    y2: 45.5104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBB011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#ED861D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_317_3228",
    x1: 31.197,
    y1: 13.5135,
    x2: 31.197,
    y2: 20.1814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBB011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#ED861D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_317_3228"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.4e8fd6ff298646c9977a194417477885.svg";
export { ForwardRef as ReactComponent };